import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Route, Switch, Redirect } from "react-router-dom";

const HomePage = ({}) => {
  return <Redirect to="/company" />;
};

export default HomePage;
